import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasKitchenFurniture = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('has_kitchen_furniture')(jsonQuery),
);
